<template>
  <div class="animated fadeIn">
    <b-row class="text-center h5 my-4">
      <b-col v-for="(step, index) in steps" :key="+(index + 1)"
        ><router-link :to="path + +(index + 1)">{{ step }}</router-link></b-col
      >
    </b-row>
    <b-progress :value="progressValue" :max="progressMax" />
  </div>
</template>

<script>
export default {
  name: "ProjectWizardHeaderNav",
  props: ["path", "step"],
  data() {
    return {
      steps: ["Customer/Grower/Type", "Submission(s)/Sample(s)", "Review"],
      firstStep: 1,
      lastStep: 3,
      progressValue: 0,
      progressMax: 100
    };
  },
  methods: {
    getStepPercent() {
      return (+this.step - 1) / (this.lastStep - 2);
    },
    getProgressValue() {
      const current = +this.step;
      const first = +this.firstStep;
      const last = +this.lastStep;

      return current <= first
        ? 12
        : current >= last
        ? 90
        : 8 + 42 * this.getStepPercent();
    },
    isActive(step) {
      return +step === +this.step;
    }
  },
  watch: {
    step() {
      this.progressValue = this.getProgressValue();
    }
  },
  mounted() {
    this.progressValue = this.getProgressValue();
  }
};
</script>
